export const customStyles = {
    headRow: {
      style: {
        // backgroundColor: '#032e15',
        backgroundColor: '#172554',
        color: '#FFFFFF',
        fontWeight: 'bold',
        fontSize: '16px',
      },
    },
    headCells: {
      style: {
        paddingLeft: '8px',
        paddingRight: '8px',
      },
    },
    rows: {
      style: {
        backgroundColor: '#F5F5F5', // Light gray background for rows
        '&:hover': {
          backgroundColor: '#E0E0E0', // Darker gray on hover
        },
      },
    },
    cells: {
      style: {
        paddingLeft: '8px',
        paddingRight: '8px',
      },
    },
  };